export interface Newsfeed {
  newsFeedId?: string;
  newsFeedMessage: string;
  link?: string;
  startDate: string;
  endDate: string;
  isActive: boolean
}

export interface LoadNewsfeedRequest {
  newsFeedRequestType: NewsFeedRequestType;
  newsFeedMessage?: string;
  deactivated?: boolean;
  page?: number;
  size?: number;
  sortBy?: string;
  sortDirection?: string;
}


export interface LoadNewsfeedResponse {
  totalRecords: number;
  bannerNewsFeeds: Newsfeed[]; //banner
  newsfeeds: Newsfeed[]; //table
}


export interface UpdateNewsFeedStatusRequest {
  newsFeedId: string;
  isActive: boolean;
}

export enum NewsFeedRequestType {
  All,
  Banner,
}
